var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.OFFSETHEIGHT - 370 + 'px' })},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.page_path,"loading":"lazy","frameborder":"0","tabindex":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }